module.exports = __webpack_public_path__ + "static/media/arrowRight.727f6b3c.svg";